// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AssetMetadata } from '@/audit/api/types';
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { ArrowForwardRounded } from '@/constants/hardfin-standard-icons';
import { Typography } from '@mui/material';

interface Props {
  property: AssetMetadata;
  isDelete?: boolean;
}

export function AuditAssetMetadataLabel(props: Props) {
  const oldValue = props.property.oldValue?.value ?? null;
  const newValue = props.property.newValue?.value ?? null;

  if (props.isDelete) {
    const label =
      props.property.oldValue === null
        ? null
        : `${props.property.oldValue.type.label} (${props.property.oldValue.value})`;

    return (
      <Typography display="flex" variant="caption" alignItems="center">
        <Typography component="span" variant="inherit" fontWeight="bold">
          {props.property.name}:&nbsp;
        </Typography>
        <AuditPropertyValue value={label} />
      </Typography>
    );
  }

  return (
    <Typography display="flex" variant="caption" alignItems="center">
      <Typography component="span" variant="inherit" fontWeight="bold">
        {props.property.name}:&nbsp;
      </Typography>
      <AuditPropertyValue value={oldValue} />
      <ArrowForwardRounded fontSize="inherit" sx={{ marginX: 1 }} />
      <AuditPropertyValue value={newValue} />
    </Typography>
  );
}
